export class AddSupportTicketDto {
    constructor(readonly message: string) {
    }
}